// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Field List Table Styles */

.field-list-table {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--color-grey-100);
  background-color: var(--color-grey-100);
  border-radius: 8px;
  overflow: hidden;
}

/* Basic mode (sidebar closed) styles */
.field-list-table.field-list-table--basic {
  width: 400px;
  gap: 8px;
  border-radius: 0px 0px 16px 16px;
  background-color: transparent;
}

.field-list-table--empty {
  padding: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.field-list-table__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background-color: var(--color-grey-98);
  background-color: var(--color-grey-98);
  border-bottom: 1px solid var(--color-grey-91);
  border-bottom: 1px solid var(--color-grey-91);
}

/* Table Action Bar for basic mode */
.field-list-table__action-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  width: 400px;
  height: 40px;
  background: transparent;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  z-index: 1;
  justify-content: flex-end;
}

/* Advanced Button for basic mode */
.field-list-table__advanced-btn {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  width: 129px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #919db4;
  border-radius: 16px;
  cursor: pointer;
  font-family: inherit;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #2a2f40;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.field-list-table__advanced-btn:hover {
  background: #f5f7fa;
  border-color: #6b7a99;
}

.field-list-table__toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.field-list-table__toggle input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.field-list-table__toggle-slider {
  position: relative;
  width: 44px;
  height: 24px;
  background-color: var(--color-grey-91);
  background-color: var(--color-grey-91);
  border-radius: 12px;
  transition: background-color 0.3s ease;
}

.field-list-table__toggle-slider::before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  left: 2px;
  top: 2px;
  background-color: var(--color-grey-100);
  background-color: var(--color-grey-100);
  border-radius: 50%;
  transition: transform 0.3s ease;
}

.field-list-table__toggle input:checked + .field-list-table__toggle-slider {
  background-color: var(--color-primary-idel);
  background-color: var(--color-primary-idel);
}

.field-list-table__toggle
  input:checked
  + .field-list-table__toggle-slider::before {
  transform: translateX(20px);
}

.field-list-table__container {
  overflow-x: auto;
  overflow-y: auto;
  max-height: calc(100vh - 300px);
}

/* Basic mode table container */
.field-list-table--basic .field-list-table__container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 400px;
  background: #ffffff;
  border: 1px solid #dce0e8;
  border-radius: 16px;
  overflow: hidden;
}

.field-list-table__table {
  width: 100%;
  border-collapse: collapse;
}

.field-list-table__th {
  padding: 12px 16px;
  text-align: left;
  background-color: var(--color-grey-98);
  background-color: var(--color-grey-98);
  border-bottom: 1px solid var(--color-grey-91);
  border-bottom: 1px solid var(--color-grey-91);
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  position: sticky;
  top: 0;
  z-index: 10;
}

/* Basic mode table header */
.field-list-table--basic .field-list-table__th {
  box-sizing: border-box;
  padding: 0px 48px;
  height: 72px;
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05);
  border-bottom: none;
  vertical-align: middle;
}

.field-list-table--basic thead tr {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 398px;
  height: 72px;
}

.field-list-table--basic .field-list-table__th:first-child {
  flex: 1;
  display: flex;
  align-items: center;
}

.field-list-table--basic .field-list-table__th:last-child {
  width: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.field-list-table__th--sortable {
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.field-list-table__th--sortable:hover {
  background-color: var(--color-grey-96);
  background-color: var(--color-grey-96);
}

.field-list-table__sort-indicator {
  margin-left: 4px;
  color: var(--color-primary-idel);
  color: var(--color-primary-idel);
}

.field-list-table__td {
  padding: 12px 16px;
  border-bottom: 1px solid var(--color-grey-91);
  border-bottom: 1px solid var(--color-grey-91);
  vertical-align: middle;
}

/* Basic mode table cells */
.field-list-table--basic .field-list-table__td {
  padding: 16px 0px;
  border-bottom: 1px solid #dce0e8;
}

.field-list-table--basic .field-list-table__td:first-child {
  padding-left: 48px;
}

.field-list-table--basic .field-list-table__td:last-child {
  padding-right: 48px;
}

.field-list-table__row {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

/* Basic mode field rows */
.field-list-table--basic .field-list-table__row {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 0px;
  width: 398px;
  height: 88px;
  background: #ffffff;
}

.field-list-table--basic .field-list-table__row .field-list-table__td {
  border-bottom: none;
}

.field-list-table--basic .field-list-table__row:not(:last-child) {
  border-bottom: 1px solid #dce0e8;
}

.field-list-table--basic
  .field-list-table__row
  .field-list-table__td:first-child {
  flex: 1;
  display: flex;
  align-items: center;
}

.field-list-table--basic
  .field-list-table__row
  .field-list-table__td:last-child {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.field-list-table__row:hover {
  background-color: var(--color-grey-99);
  background-color: var(--color-grey-99);
}

.field-list-table--basic .field-list-table__row:hover {
  background-color: #f5f7fa;
}

.field-list-table__row--selected {
  background-color: var(--color-grey-96);
  background-color: var(--color-grey-96);
}

.field-list-table--basic .field-list-table__row--selected {
  background-color: #eaeefd;
}

.field-list-table__row--selected:hover {
  background-color: var(--color-grey-96);
  background-color: var(--color-grey-96);
}

.field-list-table--basic .field-list-table__row--selected:hover {
  background-color: #eaeefd;
}

/* Water Availability Badge */
.field-list-table__water-badge {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 8px;
  gap: 10px;
  width: 72px;
  height: 24px;
  border-radius: 4px;
  font-family: inherit;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}

.field-list-table__water-badge--low {
  background: #df3044;
  color: #ffffff;
}

.field-list-table__water-badge--medium {
  background: #ffb302;
  color: #2a2f40;
}

.field-list-table__water-badge--high {
  background: #078378;
  color: #ffffff;
}

.field-list-table__water-badge--none {
  background: #dce0e8;
  color: #6b7a99;
}

/* Field Name - 3 line max with ellipsis */
.field-list-table__field-name {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  line-height: 1.4;
  max-height: calc(1.4em * 3);
  max-width: 200px;
}

.field-list-table--basic .field-list-table__field-name {
  max-width: 180px;
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/AllFarmView/FieldListTable.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uCAAuC;EACvC,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,QAAQ;EACR,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,sCAAsC;EACtC,6CAA6C;EAC7C,6CAA6C;AAC/C;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd;;0BAEwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;KACtB,sBAAsB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,uCAAuC;EACvC,uCAAuC;EACvC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,sCAAsC;EACtC,6CAA6C;EAC7C,6CAA6C;EAC7C,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;KACtB,sBAAsB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,OAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Field List Table Styles */\n\n.field-list-table {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background-color: var(--color-grey-100);\n  background-color: var(--color-grey-100);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n/* Basic mode (sidebar closed) styles */\n.field-list-table.field-list-table--basic {\n  width: 400px;\n  gap: 8px;\n  border-radius: 0px 0px 16px 16px;\n  background-color: transparent;\n}\n\n.field-list-table--empty {\n  padding: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.field-list-table__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  background-color: var(--color-grey-98);\n  background-color: var(--color-grey-98);\n  border-bottom: 1px solid var(--color-grey-91);\n  border-bottom: 1px solid var(--color-grey-91);\n}\n\n/* Table Action Bar for basic mode */\n.field-list-table__action-bar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px;\n  gap: 16px;\n  width: 400px;\n  height: 40px;\n  background: transparent;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  z-index: 1;\n  justify-content: flex-end;\n}\n\n/* Advanced Button for basic mode */\n.field-list-table__advanced-btn {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 16px;\n  gap: 8px;\n  width: 129px;\n  height: 40px;\n  background: #ffffff;\n  border: 1px solid #919db4;\n  border-radius: 16px;\n  cursor: pointer;\n  font-family: inherit;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 24px;\n  color: #2a2f40;\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.field-list-table__advanced-btn:hover {\n  background: #f5f7fa;\n  border-color: #6b7a99;\n}\n\n.field-list-table__toggle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n\n.field-list-table__toggle input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.field-list-table__toggle-slider {\n  position: relative;\n  width: 44px;\n  height: 24px;\n  background-color: var(--color-grey-91);\n  background-color: var(--color-grey-91);\n  border-radius: 12px;\n  transition: background-color 0.3s ease;\n}\n\n.field-list-table__toggle-slider::before {\n  content: '';\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  left: 2px;\n  top: 2px;\n  background-color: var(--color-grey-100);\n  background-color: var(--color-grey-100);\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n}\n\n.field-list-table__toggle input:checked + .field-list-table__toggle-slider {\n  background-color: var(--color-primary-idel);\n  background-color: var(--color-primary-idel);\n}\n\n.field-list-table__toggle\n  input:checked\n  + .field-list-table__toggle-slider::before {\n  transform: translateX(20px);\n}\n\n.field-list-table__container {\n  overflow-x: auto;\n  overflow-y: auto;\n  max-height: calc(100vh - 300px);\n}\n\n/* Basic mode table container */\n.field-list-table--basic .field-list-table__container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  width: 400px;\n  background: #ffffff;\n  border: 1px solid #dce0e8;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.field-list-table__table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.field-list-table__th {\n  padding: 12px 16px;\n  text-align: left;\n  background-color: var(--color-grey-98);\n  background-color: var(--color-grey-98);\n  border-bottom: 1px solid var(--color-grey-91);\n  border-bottom: 1px solid var(--color-grey-91);\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n/* Basic mode table header */\n.field-list-table--basic .field-list-table__th {\n  box-sizing: border-box;\n  padding: 0px 48px;\n  height: 72px;\n  background: #ffffff;\n  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05);\n  border-bottom: none;\n  vertical-align: middle;\n}\n\n.field-list-table--basic thead tr {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 398px;\n  height: 72px;\n}\n\n.field-list-table--basic .field-list-table__th:first-child {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n\n.field-list-table--basic .field-list-table__th:last-child {\n  width: auto;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.field-list-table__th--sortable {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n\n.field-list-table__th--sortable:hover {\n  background-color: var(--color-grey-96);\n  background-color: var(--color-grey-96);\n}\n\n.field-list-table__sort-indicator {\n  margin-left: 4px;\n  color: var(--color-primary-idel);\n  color: var(--color-primary-idel);\n}\n\n.field-list-table__td {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--color-grey-91);\n  border-bottom: 1px solid var(--color-grey-91);\n  vertical-align: middle;\n}\n\n/* Basic mode table cells */\n.field-list-table--basic .field-list-table__td {\n  padding: 16px 0px;\n  border-bottom: 1px solid #dce0e8;\n}\n\n.field-list-table--basic .field-list-table__td:first-child {\n  padding-left: 48px;\n}\n\n.field-list-table--basic .field-list-table__td:last-child {\n  padding-right: 48px;\n}\n\n.field-list-table__row {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n/* Basic mode field rows */\n.field-list-table--basic .field-list-table__row {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 16px 0px;\n  width: 398px;\n  height: 88px;\n  background: #ffffff;\n}\n\n.field-list-table--basic .field-list-table__row .field-list-table__td {\n  border-bottom: none;\n}\n\n.field-list-table--basic .field-list-table__row:not(:last-child) {\n  border-bottom: 1px solid #dce0e8;\n}\n\n.field-list-table--basic\n  .field-list-table__row\n  .field-list-table__td:first-child {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n\n.field-list-table--basic\n  .field-list-table__row\n  .field-list-table__td:last-child {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.field-list-table__row:hover {\n  background-color: var(--color-grey-99);\n  background-color: var(--color-grey-99);\n}\n\n.field-list-table--basic .field-list-table__row:hover {\n  background-color: #f5f7fa;\n}\n\n.field-list-table__row--selected {\n  background-color: var(--color-grey-96);\n  background-color: var(--color-grey-96);\n}\n\n.field-list-table--basic .field-list-table__row--selected {\n  background-color: #eaeefd;\n}\n\n.field-list-table__row--selected:hover {\n  background-color: var(--color-grey-96);\n  background-color: var(--color-grey-96);\n}\n\n.field-list-table--basic .field-list-table__row--selected:hover {\n  background-color: #eaeefd;\n}\n\n/* Water Availability Badge */\n.field-list-table__water-badge {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 0px 8px;\n  gap: 10px;\n  width: 72px;\n  height: 24px;\n  border-radius: 4px;\n  font-family: inherit;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  text-align: center;\n}\n\n.field-list-table__water-badge--low {\n  background: #df3044;\n  color: #ffffff;\n}\n\n.field-list-table__water-badge--medium {\n  background: #ffb302;\n  color: #2a2f40;\n}\n\n.field-list-table__water-badge--high {\n  background: #078378;\n  color: #ffffff;\n}\n\n.field-list-table__water-badge--none {\n  background: #dce0e8;\n  color: #6b7a99;\n}\n\n/* Field Name - 3 line max with ellipsis */\n.field-list-table__field-name {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-word;\n  line-height: 1.4;\n  max-height: calc(1.4em * 3);\n  max-width: 200px;\n}\n\n.field-list-table--basic .field-list-table__field-name {\n  max-width: 180px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
